import { css } from '@emotion/core'
import { visuallyHiddenCss } from 'styles'

export default {
  count: css`
    color: var(--button-primary);
  `,
  placeAndCount: css`
    display: flex;
    font-weight: bold;
    justify-content: space-between;
    padding-top: 10px;
    margin-bottom: -18px;
  `,
  showMoreContainer: css`
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
  `,
  visuallyHidden: visuallyHiddenCss,
}
